/**
 * Carbon — fallback de navigation mobile (durcissement webview).
 *
 * Le menu du thème dépend de toute la chaîne : importmap -> vendor.min.js ->
 * évaluation complète de theme.js -> customElements.define("header-sidebar").
 * Si un maillon casse (webview in-app, module non chargé, erreur d'évaluation),
 * le bouton hamburger devient inerte.
 *
 * Ce script est volontairement un script CLASSIQUE (pas un module) : il
 * s'exécute même là où les modules/importmap échouent. Zéro dépendance,
 * zéro import, tout est enveloppé dans try/catch : il ne peut ni casser la
 * page ni interférer quand theme.js fonctionne (il ne fait alors rien).
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'carbon-nav-fallback-open';
  var STYLE_ID = 'carbon-nav-fallback-style';

  function themeMenuAlive() {
    try {
      return !!(window.customElements && window.customElements.get('header-sidebar'));
    } catch (e) {
      return false;
    }
  }

  function injectStylesOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var css = '' +
      'html.' + OPEN_CLASS + ' { overflow: hidden; }' +
      'html.' + OPEN_CLASS + ' #sidebar-menu {' +
      '  display: block !important; visibility: visible !important;' +
      '  position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 2147483000;' +
      '  overflow-y: auto; -webkit-overflow-scrolling: touch;' +
      '  background: rgb(var(--background, 255 255 255));' +
      '  color: rgb(var(--text-color, 0 0 0));' +
      '  padding: 3.5rem 1.5rem 3rem;' +
      '}' +
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__linklist { list-style: none; margin: 0; padding: 0; }' +
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__linklist a,' +
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__nested-linklist a {' +
      '  display: block; padding: 0.75rem 0; color: inherit; text-decoration: none;' +
      '  border-bottom: 1px solid rgb(var(--border-color, 128 128 128) / 0.25);' +
      '}' +
      /* Les items de 1er niveau à sous-menu sont des <button> inertes sans JS :
         on les masque, leur contenu apparaît en sections dessous. */
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__main-panel .header-sidebar__linklist button[aria-controls] { display: none; }' +
      /* Les sous-panneaux sont révélés par le script ; le bouton retour sert de titre de section. */
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__sub-panel { display: block; margin-top: 1.5rem; }' +
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__back-button {' +
      '  pointer-events: none; background: none; border: 0; padding: 0.75rem 0;' +
      '  font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; color: inherit;' +
      '}' +
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__back-button svg { display: none; }' +
      /* Widgets morts sans JS (compte, sélecteurs de langue/pays) et visuels promo : masqués. */
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__footer,' +
      'html.' + OPEN_CLASS + ' #sidebar-menu .header-sidebar__promo { display: none; }' +
      'html.' + OPEN_CLASS + ' #sidebar-menu .carbon-nav-fallback-close {' +
      '  position: absolute; top: 0.75rem; right: 0.75rem; z-index: 1;' +
      '  background: none; border: 0; padding: 0.75rem; cursor: pointer;' +
      '  font-size: 1.75rem; line-height: 1; color: inherit;' +
      '}' +
      '#sidebar-menu .carbon-nav-fallback-close { display: none; }' +
      'html.' + OPEN_CLASS + ' #sidebar-menu .carbon-nav-fallback-close { display: block; }';

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function ensureCloseButton(sidebar) {
    if (sidebar.querySelector('.carbon-nav-fallback-close')) return;
    var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'carbon-nav-fallback-close';
    button.setAttribute('data-carbon-nav-fallback-close', '');
    button.setAttribute('aria-label', isFr ? 'Fermer le menu' : 'Close menu');
    button.textContent = '×';
    sidebar.insertBefore(button, sidebar.firstChild);
  }

  function openFallback() {
    var sidebar = document.getElementById('sidebar-menu');
    if (!sidebar) return;
    injectStylesOnce();
    ensureCloseButton(sidebar);
    var hiddenPanels = sidebar.querySelectorAll('.header-sidebar__sub-panel[hidden]');
    for (var i = 0; i < hiddenPanels.length; i++) {
      hiddenPanels[i].removeAttribute('hidden');
      hiddenPanels[i].setAttribute('data-carbon-nav-fallback-revealed', '');
    }
    document.documentElement.classList.add(OPEN_CLASS);
  }

  function closeFallback() {
    var root = document.documentElement;
    if (!root.classList.contains(OPEN_CLASS)) return;
    root.classList.remove(OPEN_CLASS);
    var revealed = document.querySelectorAll('#sidebar-menu [data-carbon-nav-fallback-revealed]');
    for (var i = 0; i < revealed.length; i++) {
      revealed[i].setAttribute('hidden', '');
      revealed[i].removeAttribute('data-carbon-nav-fallback-revealed');
    }
  }

  document.addEventListener('click', function (event) {
    try {
      if (!event.target || !event.target.closest) return;
      var toggle = event.target.closest('button[aria-controls="sidebar-menu"]');
      var close = event.target.closest('[data-carbon-nav-fallback-close]');

      if (document.documentElement.classList.contains(OPEN_CLASS)) {
        if (toggle || close) {
          event.preventDefault();
          closeFallback();
        }
        return; // clic sur un lien : navigation normale
      }

      if (!toggle) return;
      if (themeMenuAlive()) return; // theme.js est vivant : il gère, on ne fait rien

      event.preventDefault();
      openFallback();
    } catch (e) {
      /* Ce fallback ne doit jamais casser la page. */
    }
  });

  // Si theme.js finit par arriver (réseau lent), on referme le fallback :
  // le composant natif reprend la main proprement.
  try {
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('header-sidebar').then(function () {
        closeFallback();
      });
    }
  } catch (e) {
    /* no-op */
  }
})();
